export default __webpack_public_path__ + "static/media/category.2830b6ac.svg";